/* Dọn mấy nút nổi của app (Zalo, Reward, popup mã giảm giá, khay so sánh).

   LỖI ĐO ĐƯỢC, không phải chuyện thẩm mỹ: mở giỏ hàng trên điện thoại 390px,
   nút Reward nằm ở x 254–370 / y 704–754 — ĐÈ ĐÚNG lên dòng "Tạm tính". Gọi
   document.elementFromPoint ngay giữa ô giá trả về null, tức con số tiền
   không những bị che mà còn không bấm tới được. Zalo thì đè góc nút Thanh
   toán. Trên máy tính y hệt.

   Làm hai việc:
   1) Có lớp phủ nào đang mở (giỏ hàng, popup xem nhanh, menu…) thì giấu hết
      mấy nút nổi đi. Đây là lúc khách đang làm một việc dứt điểm, không phải
      lúc mời chat.
   2) Thêm một nút mũi tên nhỏ để khách tự thu gọn cả cụm khi thấy vướng —
      nhớ lựa chọn trong phiên làm việc.

   KHÔNG đua z-index với app: Zalo đang để 2147483002, gần kịch trần. Đua thì
   app cập nhật một phát là thua. Giấu hẳn thì chắc chắn hơn. */
(function () {
  'use strict';

  /* CHÚ Ý: việc GIẤU các nút nổi do CSS làm (html.egr-nofloat / .egr-dock-min
     trong eguru-redesign.css). Danh sách ở đây chỉ dùng để ĐO xem còn nút nào
     tồn tại không — sửa danh sách ở một nơi thì phải sửa nốt bên CSS. */
  var CAC_NUT = '#rawa-button, .BLOY-widget, .BLOY-popup, shopify-forms-embed';

  /* Chỉ neo vị trí theo hai nút LUÔN NẰM ĐÓ. Ban đầu neo theo cả CAC_NUT thì
     lúc popup Reward bung ra (cao 371px), nút thu gọn bị đẩy lên tận giữa màn
     hình — đo được y=287 trên máy 844px. Popup là thứ đến rồi đi, không phải
     mốc để bám. */
  var NEO = '#rawa-button, .BLOY-widget';

  var KEY = 'egrDockMin';
  var root = document.documentElement;
  var dock = null;

  /* ---------- 1. Giấu khi có lớp phủ đang mở ---------- */

  /* body.overflow-hidden là cờ chung theme dùng cho MỌI ngăn kéo/hộp thoại
     (giỏ hàng, menu, tìm kiếm) nên bắt một cờ này là phủ hết, khỏi phải liệt
     kê từng loại. egr-qv-on là popup xem nhanh của mình. */
  function dangCoLopPhu() {
    return document.body.classList.contains('overflow-hidden') ||
           root.classList.contains('egr-qv-on') ||
           !!document.querySelector('cart-drawer.active, .menu-drawer.active');
  }

  function capNhatLopPhu() {
    root.classList.toggle('egr-nofloat', dangCoLopPhu());
  }

  /* ---------- 2. Nút thu gọn ---------- */

  function dangThuGon() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function luu(v) {
    try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {}
  }

  function dungDock() {
    if (dock) return dock;
    dock = document.createElement('button');
    dock.type = 'button';
    dock.className = 'egr-dock';
    dock.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    dock.addEventListener('click', function () {
      var min = !root.classList.contains('egr-dock-min');
      root.classList.toggle('egr-dock-min', min);
      luu(min);
      capNhatNhan();
      // Thu gọn xong cụm biến mất -> phải đo lại chỗ đặt nút
      requestAnimationFrame(datCho);
    });
    document.body.appendChild(dock);
    return dock;
  }

  function capNhatNhan() {
    if (!dock) return;
    var min = root.classList.contains('egr-dock-min');
    dock.setAttribute('aria-label', min ? 'Hiện lại nút liên hệ' : 'Thu gọn nút liên hệ');
    dock.setAttribute('title', min ? 'Hiện lại nút liên hệ' : 'Thu gọn nút liên hệ');
    dock.classList.toggle('is-min', min);
  }

  /* Đặt nút ngay TRÊN cụm nút nổi, canh phải theo đúng mép phải của cụm.
     Đo tại chỗ thay vì ghi đè toạ độ của app: mỗi app tự đặt vị trí riêng và
     còn đổi theo cỡ màn hình, ghi đè cứng là chệch. */
  /* THỨ TỰ ĐỌC-RỒI-GHI, KHÔNG ĐƯỢC ĐẢO. Bản cũ gọi appendChild (GHI) ngay đầu
     hàm rồi mới getBoundingClientRect (ĐỌC) — mỗi lần đo là ép trình duyệt dựng
     lại toàn bộ bố cục vì DOM vừa bị đổi. Lighthouse đo được 94ms "Forced
     reflow" dồn vào file này, đúng lúc trang đang tải nên tính hết vào TBT.
     Giờ đo xong mới dời node và ghi style: cả hàm chỉ còn MỘT lần dựng lại. */
  function datCho() {
    if (!dock) return;

    /* ĐẾM TRƯỚC, RẼ NHÁNH SAU. Bản cũ thoát sớm ở nhánh thu gọn nên không bao
       giờ chạy tới phép kiểm "còn nút nổi nào không": khách bấm thu gọn ở
       trang có Zalo (nhớ trong phiên) rồi sang trang app không nạp → còn trơ
       một nút mũi tên bấm mãi không ra gì. */
    var con = 0;
    var phai = null, tren = null;
    document.querySelectorAll(CAC_NUT).forEach(function (el) {
      con++;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (r.height > 120) return;   // bỏ qua popup bung to, chỉ neo theo nút nhỏ
      if (!el.matches(NEO)) return;
      if (phai === null || window.innerWidth - r.right < phai) phai = window.innerWidth - r.right;
      if (tren === null || window.innerHeight - r.top > tren) tren = window.innerHeight - r.top;
    });

    if (!con) { dock.style.display = 'none'; return; }

    /* Giữ nút luôn là phần tử cuối cùng của body. Popup Shopify Forms cũng để
       z-index kịch trần nên bằng điểm; bằng điểm thì cái đứng SAU trong DOM
       vẽ đè lên. App chèn muộn hơn mình nên phải đẩy lại xuống cuối, không
       thì bấm vào nút này lại trúng lớp phủ của popup.
       KHÔNG dời khi nút đang được focus: appendChild là DI CHUYỂN node, làm
       mất focus của người đang dùng bàn phím. */
    if (document.body.lastElementChild !== dock && document.activeElement !== dock) {
      document.body.appendChild(dock);
    }

    if (root.classList.contains('egr-dock-min')) {
      dock.style.display = '';
      dock.style.right = '1.2rem';
      dock.style.bottom = '1.2rem';
      return;
    }
    if (phai === null) { dock.style.display = 'none'; return; }
    dock.style.display = '';
    dock.style.right = Math.max(4, phai) + 'px';
    dock.style.bottom = (tren + 8) + 'px';
  }

  /* Gộp nhiều lời gọi vào một khung hình. datCho() đo getBoundingClientRect
     (ép trình duyệt tính lại bố cục) nên gọi thẳng từ sự kiện là tốn vô ích. */
  var cho = false;
  function datChoSau() {
    if (cho) return;
    cho = true;
    requestAnimationFrame(function () { cho = false; datCho(); });
  }

  /* ---------- khởi động ---------- */

  function init() {
    dungDock();
    root.classList.toggle('egr-dock-min', dangThuGon());
    capNhatNhan();
    capNhatLopPhu();
    datCho();

    new MutationObserver(capNhatLopPhu).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(capNhatLopPhu).observe(root, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', datChoSau, { passive: true });
    /* CỐ Ý KHÔNG nghe 'scroll': Zalo và Reward đều position:fixed nên vị trí
       của chúng KHÔNG đổi khi cuộn — đo lại mỗi khung hình cuộn là lãng phí
       100%, mà lại ép tính bố cục liên tục nên máy yếu thấy giật. */

    /* App nạp muộn và tự chèn nút vào lúc nào không biết trước, nên đo lại vài
       lần trong 20 giây đầu rồi thôi — theo dõi mãi thì tốn công vô ích.

       Mỗi mốc CHỜ LÚC LUỒNG CHÍNH RẢNH mới đo (requestIdleCallback). datCho()
       gọi getBoundingClientRect nên ép trình duyệt dựng lại bố cục; nổ đúng lúc
       trang đang tải là cộng thẳng vào TBT. Lighthouse vẫn còn ghi 34ms "Buộc
       chỉnh lại luồng" cho file này sau khi đã sửa thứ tự đọc-ghi.

       KHÔNG bỏ mốc nào dù 300ms trông như chạy không: đo thật trên trang live
       thấy nút Zalo hiện lúc 577ms và BLOY lúc 803ms, tức mốc 800ms đang làm
       việc thật. Có `timeout: 500` để lỡ luồng chính bận liên tục thì vẫn đo,
       không để nút mũi tên đứng sai chỗ. */
    var ranhRoi = window.requestIdleCallback
      ? function (fn) { window.requestIdleCallback(fn, { timeout: 500 }); }
      : datChoSau;
    var moc = [300, 800, 1500, 3000, 6000, 12000, 20000];
    moc.forEach(function (ms) { setTimeout(function () { ranhRoi(datChoSau); }, ms); });

    /* Không khớp selector nào sau 20 giây thì gần như chắc chắn app đã đổi tên
       class. Lúc đó CSS giấu nút nổi cũng trượt theo, và lỗi "nút Reward đè
       lên dòng tiền trong giỏ" quay lại mà không ai hay. Kêu một tiếng trong
       console để còn lần ra được. */
    setTimeout(function () {
      if (!document.querySelectorAll(CAC_NUT).length && window.console && console.warn) {
        console.warn('[egr-floatdock] không thấy nút nổi nào — app có thể đã đổi selector, kiểm tra lại danh sách trong file này và trong eguru-redesign.css');
      }
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
